module.exports = __webpack_public_path__ + "static/media/14UNEP23.93a25ce9.jpg";